import {Directive, Input, OnInit, TemplateRef} from '@angular/core';
import isRequired from '../../decorators/isRequired.decorator';

@Directive({
    selector: '[stepperSection]'
})
export class StepperSectionDirective implements OnInit {

    @Input() isCanActivate: boolean = true;
    @Input() isValid: boolean = true;

    @isRequired()
    @Input() icon: string;

    @isRequired()
    @Input() title: string;

    @Input() stepHidden: boolean = false;
    hidden: boolean = false;

    constructor(public templateRef: TemplateRef<unknown>) {
    }

    ngOnInit(): void {
    }

}
